import type { AppAbility } from '@/lib/casl'
import { OrganizationType } from '@/lib/enums/OrganizationType'
import type { Organization } from './organizations.types'

export function canEditOrganization(
  ability: Pick<AppAbility, 'can'> | null | undefined,
  organization: Pick<Organization, 'type'> | null | undefined
): boolean {
  if (!ability || !organization) {
    return false
  }

  return organization.type === OrganizationType.Global.Value
    ? ability.can('manage', 'global-organization')
    : ability.can('edit', 'organizations')
}
